import * as React from 'react';
import { Button, ButtonProps } from '../../Button';
import { ScrollerItem } from '../../Scroller';
import { useScrollspyContext } from '../Scrollspy.context';

export interface ScrollspyButtonProps extends ButtonProps {
    /**
     * The content of the component.
     */
    children: React.ReactNode;

    /**
     * The unique value of the corresponding `ScrollspyTarget` that will be scrolled into view when this button is clicked.
     */
    targetValue: string;
}

export function ScrollspyButton(props: Readonly<ScrollspyButtonProps>): React.JSX.Element {
    const { children, targetValue, ref, ...other } = props;

    const { activeValue, onButtonClick } = useScrollspyContext();
    const active = targetValue === activeValue;

    return (
        <ScrollerItem active={active}>
            <Button
                ref={ref}
                button={true}
                data-target={targetValue}
                data-scrollspy-anchor={true}
                color="neutral"
                variant={active ? 'filled' : 'outlined'}
                onClick={() => onButtonClick?.(targetValue)}
                {...other}
            >
                {children}
            </Button>
        </ScrollerItem>
    );
}
